import { useState, useEffect, useCallback } from 'react';
import useUnauthorize from './useUnauthorize';
import { useToken } from '../common/helper';
import { CourierData, GetCompanyCouriers } from '@/apis/lookup';

interface UseFetchCompanyCouriersReturn {
  couriers: CourierData[];
  refetchCompanyCouriers: () => void;
}

const useFetchCompanyCouriers = (): UseFetchCompanyCouriersReturn => {
  const { checkTokenExpiry } = useToken();
  const { unauthorize } = useUnauthorize();
  const [couriers, setCouriers] = useState<CourierData[]>([]);

  const fetchCompanyCouriers = useCallback(() => {
    const token = checkTokenExpiry();
    if (!token) {
      return;
    }
    GetCompanyCouriers(token)
      .then((res) => {
        const responseData = res?.data;
        if (
          responseData?.data?.is_success &&
          Array.isArray(responseData?.data?.data?.couriers)
        ) {
          setCouriers(responseData.data.data?.couriers);
        } else {
          setCouriers([]);
        }
      })
      .catch((err) => {
        unauthorize(err);
        setCouriers([]);
      });
  }, [checkTokenExpiry, unauthorize]);

  useEffect(() => {
    fetchCompanyCouriers();
  }, [fetchCompanyCouriers]);

  return { couriers, refetchCompanyCouriers: fetchCompanyCouriers };
};

export default useFetchCompanyCouriers;
